import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootAppState } from 'store/types';
import { getContents } from 'store/contents/selectors';
import ContentList from 'components/contents/ContentList/ContentList';
import { AccordionContent as AccordionContentItem } from './Accordion.styled';

type AccordionContentProps = {
  inverted: boolean;
  childrenElements: any[];
  content: string;
  height: number | string;
};

class AccordionContent extends React.PureComponent<AccordionContentProps & ConnectedProps<typeof connector>> {
  render() {
    const { inverted, childrenContents, height } = this.props;
    return (
      <AccordionContentItem height={height} duration={300}>
        {childrenContents.length > 0 && (
          <ContentList items={childrenContents} isLoading={false} inverted={inverted} />
        )}
      </AccordionContentItem>
    );
  }
}

function mapStateToProps(state: RootAppState, ownProps: AccordionContentProps) {
  return {
    childrenContents: getContents(state, ownProps.childrenElements)
  };
}

const connector = connect(mapStateToProps);
export default connector(AccordionContent);
